import { useQuery } from '@tanstack/react-query';

import { myUpcomingRenewalMembersKey, requestMyUpcomingRenewalMembers } from './membersApi';

/**
 * The rows of the directory's Upcoming Renewals view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `myUpcomingRenewalMembers` is a pure read, so infrastructure errors
 * travel the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMyUpcomingRenewalMembers() {
  return useQuery({ queryKey: myUpcomingRenewalMembersKey, queryFn: requestMyUpcomingRenewalMembers });
}
